import React from "react";

const CodeNameValue = ({ value }) => {
  const code =
    value?.code !== null && value?.code !== undefined
      ? String(value.code).trim()
      : "";
  const name =
    value?.name !== null && value?.name !== undefined
      ? String(value.name).trim()
      : "";

  if (!code && !name) {
    return null;
  }

  if (code && name) {
    return (
      <div className="inline-flex flex-col items-end gap-1.5 sm:flex-row sm:items-center sm:justify-end sm:gap-2.5">
        <span className="inline-flex shrink-0 items-center rounded-md bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700 ring-1 ring-inset ring-blue-600/10">
          {code}
        </span>
        <span className="text-sm text-gray-900 leading-snug text-right sm:text-left">
          {name}
        </span>
      </div>
    );
  }

  if (code) {
    return (
      <span className="inline-flex shrink-0 items-center rounded-md bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700 ring-1 ring-inset ring-blue-600/10">
        {code}
      </span>
    );
  }

  return <span className="text-sm text-gray-900 leading-snug">{name}</span>;
};

export default CodeNameValue;
